import {
    Background,
    BackgroundColor,
    Container,
    ContainerType,
    Spacer,
    SpacerVariant,
    backgroundNeutralColorsOptions,
    spacerOptionsAll,
} from "../components/layout"
import ImageEditor, { AspectRatio } from "../Image"
import Typography, { TypographyElement } from "../RedesignTypography"

import { Color } from "../components/typography"
import React from "react"
import classNames from "classnames"
import { types } from "react-bricks/frontend"

interface ProductIntroProps {
    background: { color: BackgroundColor } | BackgroundColor
    reversePosition: boolean
    text: TypographyElement[]
    imageDesktop?: types.IImageSource
    spacerTop?: SpacerVariant
    spacerBottom?: SpacerVariant
}

const ProductIntro: types.Brick<ProductIntroProps> = ({ background, reversePosition, spacerTop, spacerBottom }) => {
    const bgColor = typeof background === "object" ? background.color : background

    return (
        <Background color={bgColor}>
            <Container
                type={ContainerType.Redesign}
                className="flex min-h-screen-w/o-header flex-col items-center justify-center"
            >
                <Spacer variant={spacerTop} />
                <div className="flex w-full flex-col items-center justify-center gap-y-3.5 xs:gap-y-7 sm:gap-y-10 md:grid md:grid-cols-12 md:gap-x-3.75 lg:gap-x-5">
                    <div
                        className={classNames(
                            "relative z-1 w-full sm:max-w-[428px] md:col-span-6 md:row-start-1 md:max-w-fit xl:col-span-4",
                            reversePosition
                                ? "order-2 md:-col-end-2 xl:-col-end-3"
                                : "order-1 md:col-start-2 xl:col-start-3"
                        )}
                    >
                        <Color>
                            <Typography size="UI1" allowList={["bold", "sup", "small", "link", "ul"]} />
                        </Color>
                    </div>
                    <div
                        className={classNames(
                            "relative z-0 md:row-start-1 md:w-auto",
                            reversePosition
                                ? "order-1 -mr-[146px] xs:-mr-[180px] sm:-mr-[250px] md:col-start-2 md:mr-0 xl:col-start-3"
                                : "order-2 -ml-[146px] xs:-ml-[180px] sm:-ml-[250px] md:-col-end-2 md:ml-0 xl:-col-end-3"
                        )}
                    >
                        <div
                            className={classNames(
                                "w-[310px] xs:w-[379px] sm:w-[518px] md:absolute md:top-1/2 md:h-[413px] md:w-[532px] md:-translate-y-1/2 lg:h-[542px] lg:w-[699px] xl:h-[578px] xl:w-[745px]",
                                reversePosition ? "md:left-0" : "md:right-0"
                            )}
                        >
                            <div className="aspect-h-7 aspect-w-9">
                                <ImageEditor
                                    aspectRatio={AspectRatio["9/7"]}
                                    maxWidth={745}
                                    propName="imageDesktop"
                                    className="h-full w-full object-cover"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <Spacer variant={spacerBottom} />
            </Container>
        </Background>
    )
}

ProductIntro.schema = {
    name: "ProductIntro",
    label: "Product Intro",
    previewImageUrl: `${process.env.IMG_CDN_URL_ASSETS}/lavita.de/startseite/screenshots_bricks/ProductIntro.png`,
    sideEditProps: [
        {
            name: "reversePosition",
            label: "Reverse Position",
            type: types.SideEditPropType.Boolean,
        },
        {
            name: "background",
            label: "Background",
            type: types.SideEditPropType.Select,
            selectOptions: {
                display: types.OptionsDisplay.Color,
                options: backgroundNeutralColorsOptions,
            },
        },
        {
            groupName: "Spacer",
            props: [
                {
                    name: "spacerTop",
                    label: "Spacer Top",
                    type: types.SideEditPropType.Select,
                    selectOptions: {
                        options: spacerOptionsAll,
                        display: types.OptionsDisplay.Select,
                    },
                },
                {
                    name: "spacerBottom",
                    label: "Spacer Bottom",
                    type: types.SideEditPropType.Select,
                    selectOptions: {
                        options: spacerOptionsAll,
                        display: types.OptionsDisplay.Select,
                    },
                },
            ],
        },
    ],
    getDefaultProps: (): ProductIntroProps => ({
        background: { color: BackgroundColor.Beige },
        reversePosition: false,
        text: [
            {
                type: "paragraph",
                children: [
                    {
                        text: "Lorem Ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus tortor, dignissim sit amet, adipiscing nec, ultricies sed, dolor.",
                    },
                ],
            },
        ],
        spacerTop: SpacerVariant.Base,
        spacerBottom: SpacerVariant.Base,
    }),
}

export default ProductIntro
